import { h } from 'vue'

// Icons stacked in one box, as Font Awesome's layers did; each child can
// move and shrink with its transform prop.
export default {
  name: 'IconLayers',
  render() {
    return h('span', { class: 'fa-layers' }, this.$slots.default?.())
  },
}
